import { render, staticRenderFns } from "./WBtnDelete.vue?vue&type=template&id=155711b2&scoped=true&"
import script from "./WBtnDelete.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnDelete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155711b2",
  null
  
)

export default component.exports